import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Donations from "./components/Donations";
import Navbar from "./components/Navbar";
import Media from "./components/Media";
import About from "./components/About";
import Contact from "./components/Contact";
import AdvisoryBoard from "./components/AdvisoryBoard";
import Footer from "./components/Footer";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Faq from "./components/faq";
import SuccessStories from "./components/SuccessStories";

function App() {
  return (
    <Router>
      <Navbar /> {/* Place Navbar outside Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Donations" element={<Donations />} />
        <Route path="/Media" element={<Media />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AdvisoryBoard" element={<AdvisoryBoard />} />
        <Route path="/Terms" element={<TermsOfService />} />
        <Route path="/Privacy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/success-stories" element={<SuccessStories />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;